import { z } from 'zod';

export interface ChatContextRegistry {
  getPrompt: (instance: z.$output) => string;
}

export const chatContextRegistry = z.registry<ChatContextRegistry>();
